<div class="sofco-theme-dark background">
  <div class="grid-container">
    <ng-content></ng-content>
  </div>
</div>
